var map = {
	"./add-item.svg": 452,
	"./amazon-logo.png": 453,
	"./apple-logo.png": 454,
	"./arrow-white.svg": 455,
	"./arrow.svg": 456,
	"./avatar.jpeg": 457,
	"./back-active.svg": 458,
	"./back-deactive.svg": 459,
	"./checked.svg": 460,
	"./clipboard.svg": 461,
	"./coins.svg": 462,
	"./cursor-upload.png": 463,
	"./cursor-upload.svg": 464,
	"./delivery.svg": 465,
	"./delivery_shipment_2.svg": 466,
	"./demo-request/demo-request-bg.svg": 467,
	"./empty-box.svg": 468,
	"./hexadecimal_color_wheel_lg.png": 469,
	"./horizontal-line.svg": 470,
	"./info-active.svg": 471,
	"./info-deactive.svg": 472,
	"./login/login-bg.svg": 473,
	"./logo.png": 474,
	"./logos/peekage.png": 475,
	"./logos/peekage.svg": 476,
	"./map.png": 477,
	"./message-circle.svg": 478,
	"./nike-logo.jpg": 479,
	"./no-image.png": 480,
	"./overlaymenu.svg": 481,
	"./package.svg": 482,
	"./pin-icon-deactive.svg": 483,
	"./pin-icon-selected.svg": 484,
	"./pin-icon.svg": 485,
	"./plus-green.svg": 486,
	"./reset.svg": 487,
	"./sample-images/nike-shoes.jpeg": 488,
	"./trash-black.svg": 489,
	"./trash-white.svg": 490,
	"./underconstruct.png": 491,
	"./warehouse-map.png": 492,
	"./widget/theme/basic-01.png": 493,
	"./widget/theme/basic-02.png": 494,
	"./widget/theme/basic-03.png": 495,
	"./widget/theme/basic-04.png": 496,
	"./widget/theme/basic-05.png": 497,
	"./widget/theme/basic-06.png": 498,
	"./widget/theme/basic-07.png": 499,
	"./widget/theme/basic-08.png": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 451;